var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { axiosPrivate } from "../../../../../api/axios";
import { PaymentProcessor } from "../../types/PaymentProcessorTypes";
export const initPayWithCustomer = (setLoading, setPublicKey, setPaymentIntentId, setClientSecret, setPaymentProcessor) => (body) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c, _d, _e, _f;
    setLoading(true);
    const res = yield axiosPrivate.post(`/InitPayWithCustomer`, body);
    if (res.data.success) {
        if ((_a = res.data) === null || _a === void 0 ? void 0 : _a.publicKey) {
            setPublicKey((_b = res.data) === null || _b === void 0 ? void 0 : _b.publicKey);
            setPaymentProcessor(PaymentProcessor.TAP);
        }
        if ((_c = res.data) === null || _c === void 0 ? void 0 : _c.paymentIntentId) {
            setPaymentIntentId((_d = res.data) === null || _d === void 0 ? void 0 : _d.paymentIntentId);
            setPaymentProcessor(PaymentProcessor.STRIPE);
        }
        if ((_e = res.data) === null || _e === void 0 ? void 0 : _e.clientSecret) {
            setClientSecret((_f = res.data) === null || _f === void 0 ? void 0 : _f.clientSecret);
            setPaymentProcessor(PaymentProcessor.STRIPE);
        }
        else {
            setPaymentProcessor(PaymentProcessor.AUTHORIZE);
        }
    }
    setLoading(false);
});
export const updatePayInitiationWithCustomer = (setLoading, setPublicKey, setPaymentIntentId, setClientSecret) => (body) => __awaiter(void 0, void 0, void 0, function* () {
    var _g, _h, _j, _k, _l, _m;
    const res = yield axiosPrivate.post(`/UpdatePayInitiationWithCustomer`, body);
    if (res.data.success) {
        if ((_g = res.data) === null || _g === void 0 ? void 0 : _g.publicKey) {
            setPublicKey((_h = res.data) === null || _h === void 0 ? void 0 : _h.publicKey);
        }
        if ((_j = res.data) === null || _j === void 0 ? void 0 : _j.paymentIntentId) {
            setPaymentIntentId((_k = res.data) === null || _k === void 0 ? void 0 : _k.paymentIntentId);
        }
        if ((_l = res.data) === null || _l === void 0 ? void 0 : _l.clientSecret) {
            setClientSecret((_m = res.data) === null || _m === void 0 ? void 0 : _m.clientSecret);
        }
    }
    setLoading(false);
});
export const initPayWithPaymentMethod = (setLoading, setPublicKey, setPaymentIntentId, setClientSecret, setDoesPaymentIntentExist, setPaymentProcessor) => (body) => __awaiter(void 0, void 0, void 0, function* () {
    var _o, _p, _q, _r, _s, _t;
    setLoading(true);
    const res = yield axiosPrivate.post(`/InitPayWithPaymentMethod`, body);
    if (res.data.success) {
        if ((_o = res.data) === null || _o === void 0 ? void 0 : _o.publicKey) {
            setPublicKey((_p = res.data) === null || _p === void 0 ? void 0 : _p.publicKey);
            setPaymentProcessor(PaymentProcessor.TAP);
        }
        if ((_q = res.data) === null || _q === void 0 ? void 0 : _q.paymentIntentId) {
            setPaymentIntentId((_r = res.data) === null || _r === void 0 ? void 0 : _r.paymentIntentId);
            setPaymentProcessor(PaymentProcessor.STRIPE);
        }
        if ((_s = res.data) === null || _s === void 0 ? void 0 : _s.clientSecret) {
            setClientSecret((_t = res.data) === null || _t === void 0 ? void 0 : _t.clientSecret);
            setPaymentProcessor(PaymentProcessor.STRIPE);
        }
        else {
            setPaymentProcessor(PaymentProcessor.AUTHORIZE);
        }
        setDoesPaymentIntentExist(true);
    }
    setLoading(false);
});
export const updatePayInitiation = (setLoading, setPublicKey, setPaymentIntentId, setClientSecret, setDoesPaymentIntentExist, request) => (amount) => __awaiter(void 0, void 0, void 0, function* () {
    var _u, _v, _w, _x, _y, _z;
    setLoading(true);
    const res = yield axiosPrivate.post(`/UpdatePayInitiation`, request, {
        params: { amount: amount },
    });
    if (res.data.success) {
        if ((_u = res.data) === null || _u === void 0 ? void 0 : _u.publicKey) {
            setPublicKey((_v = res.data) === null || _v === void 0 ? void 0 : _v.publicKey);
        }
        if ((_w = res.data) === null || _w === void 0 ? void 0 : _w.paymentIntentId) {
            setPaymentIntentId((_x = res.data) === null || _x === void 0 ? void 0 : _x.paymentIntentId);
        }
        if ((_y = res.data) === null || _y === void 0 ? void 0 : _y.clientSecret) {
            setClientSecret((_z = res.data) === null || _z === void 0 ? void 0 : _z.clientSecret);
        }
        setDoesPaymentIntentExist(true);
    }
    setLoading(false);
});
